import { isTimePermissionEnabled } from '../config/applicationFeatures';
import type { NativeStackNavigationProp } from '@react-navigation/native-stack';
import { routes, type RootStackParamList } from '../constants/routes';
import type {
  HrAdminCompensatoryWorkItem,
  HrAdminLeaveItem,
  HrAdminPermissionItem,
  HrAdminWfhItem,
} from '../types/attendance';
import {
  isApprovedWorkflowStatus,
  isPendingWorkflowActionStatus,
} from './workflowStatus';

type DashboardNavigation = NativeStackNavigationProp<RootStackParamList>;

export function openDashboardLeaveDetails(
  navigation: DashboardNavigation,
  item: HrAdminLeaveItem,
) {
  if (!item.leaveApplicationId) return;
  navigation.navigate(routes.leaveDetails, {
    leaveApplicationId: item.leaveApplicationId,
    applicationNumber: item.applicationNumber,
    leaveTypeName: item.leaveTypeName,
    leaveFromDate: item.leaveFromDate,
    leaveToDate: item.leaveToDate,
    totalDays: item.totalDays,
    sessionType: item.sessionType,
    sessionTypeName: item.sessionTypeName,
    statusCode: item.statusCode,
    applicationDate: item.applicationDate,
  });
}

export function openDashboardLeaveStatus(
  navigation: DashboardNavigation,
  item: HrAdminLeaveItem,
) {
  if (
    isPendingWorkflowActionStatus(item.statusCode) &&
    item.workflowInstanceId
  ) {
    navigation.navigate(routes.leaveApproval, {
      workflowInstanceId: item.workflowInstanceId,
    });
    return;
  }
  if (isApprovedWorkflowStatus(item.statusCode)) {
    openDashboardLeaveDetails(navigation, item);
  }
}

export function openDashboardWfhDetails(
  navigation: DashboardNavigation,
  item: HrAdminWfhItem,
) {
  if (!item.wfhRequestId) return;
  navigation.navigate(routes.wfhDetails, {
    wfhRequestId: item.wfhRequestId,
  });
}

export function openDashboardWfhStatus(
  navigation: DashboardNavigation,
  item: HrAdminWfhItem,
) {
  if (
    isPendingWorkflowActionStatus(item.statusCode) &&
    item.workflowInstanceId
  ) {
    navigation.navigate(routes.wfhApproval, {
      workflowInstanceId: item.workflowInstanceId,
    });
    return;
  }
  if (isApprovedWorkflowStatus(item.statusCode)) {
    openDashboardWfhDetails(navigation, item);
  }
}

export function openDashboardPermissionDetails(
  navigation: DashboardNavigation,
  item: HrAdminPermissionItem,
) {
  if (!isTimePermissionEnabled()) return;
  if (!item.permissionRequestId) return;
  navigation.navigate(routes.timePermissionDetails, {
    permissionRequestId: item.permissionRequestId,
  });
}

export function openDashboardPermissionStatus(
  navigation: DashboardNavigation,
  item: HrAdminPermissionItem,
) {
  if (!isTimePermissionEnabled()) return;
  if (
    isPendingWorkflowActionStatus(item.statusCode) &&
    item.workflowInstanceId
  ) {
    navigation.navigate(routes.timePermissionApproval, {
      workflowInstanceId: item.workflowInstanceId,
    });
    return;
  }
  if (isApprovedWorkflowStatus(item.statusCode)) {
    openDashboardPermissionDetails(navigation, item);
  }
}

export function openDashboardCompensatoryWork(
  navigation: DashboardNavigation,
  item: HrAdminCompensatoryWorkItem,
) {
  if (
    !isPendingWorkflowActionStatus(item.statusCode) &&
    !isApprovedWorkflowStatus(item.statusCode)
  ) {
    return;
  }
  navigation.navigate(routes.adminLeaveRequests, {
    compensatoryWorkRequestId: item.compensatoryWorkRequestId,
  });
}
